import React from "react";
import Slider from "react-slick";
import TextCard from "./TextCard";
import { share } from "../../utils/Helper";

function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/images/rightarrow2.svg" className="" alt="" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <img src="/assets/images/leftarrow2.svg" className="" alt="" />
    </div>
  );
}

const GraphicSlider = ({ graphics, handleShareData, sharetext }) => {
  var settings = {
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    dots: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="reel_slider">
        <Slider {...settings}>
          {graphics.map((graphic, index) => (
            <div key={index}>
              <div className="textcard_pad">
                <div className="textcard_bg">
                  <button
                    className="quote_share quote_pos"
                    onClick={() => {
                      share(
                        graphic.id,
                        sharetext,
                        "youtube",
                        `https://www.narendramodi.in/parikshapecharcha2025/${graphic.episode_id}/graphics/${graphic.id}`
                      );
                      handleShareData(
                        `https://www.narendramodi.in/parikshapecharcha2025/${graphic.episode_id}/graphics/${graphic.id}`,
                        sharetext,
                        sharetext,
                        "youtube"
                      );
                    }}
                  >
                    <img src="/assets/images/shareorange.svg" alt="" /> Share
                  </button>
                  <img
                    src={graphic.image_url}
                    className="visual_banner"
                    alt=""
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default GraphicSlider;
